import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from "redux-saga";

import authSlice from '../slice/authSlice';
import userSlice from '../slice/userSlice';
import contactusSlice from '../slice/contactusSlice';


import bannerReducer from '../slice/bannerSlice';
import khajurahoPackageReducer from '../slice/khajurahoPackageSlice';
import enquiryReducer from '../slice/enquirySlice';
import videoReducer from '../slice/videoSlice';
import testimonialReducer from '../slice/testimonialSlice';
import visitReducer from '../slice/visitSlice';
import galleryReducer from '../slice/gallerySlice';
import bookingReducer from '../slice/bookingSlice';
import serviceReducer from '../slice/serviceSlice';


import rootSaga from '../apis/rootSaga';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    contact: contactusSlice,
    banner: bannerReducer,
    khajurahoPackage: khajurahoPackageReducer,
    enquiry: enquiryReducer,
    video: videoReducer,
    testimonial: testimonialReducer,
    visit: visitReducer,
    gallery: galleryReducer,
    booking: bookingReducer,
    service: serviceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
